import Vue from 'vue'
import Router from 'vue-router'

// 登录
import Login from '@/pages/sys/login.vue'   // 登录页

// Home
import Home from '@/pages/home/index.vue'   // Home页

// 数据总览
import OverviewDataParents from '@/pages/home/overviewData/index.vue'
import OverviewData from '@/pages/home/overviewData/overviewData/index.vue'

// 运营数据
import DataEffect from '@/pages/home/dataEffect/index.vue'   // 数据效果主页
import AccountData from '@/pages/home/dataEffect/accountData/index.vue'
import PlanData from '@/pages/home/dataEffect/planData/index.vue'
import OrderData from '@/pages/home/dataEffect/orderData/index.vue'
import CustomerData from '@/pages/home/dataEffect/customerData/index.vue'


// 商品信息
import GoodsInfo from '@/pages/home/goodsInfo/index.vue'   // 商品信息主页
import GoodsList from '@/pages/home/goodsInfo/goodsList/index.vue'
import Taobao from '@/pages/home/goodsInfo/taobao/index.vue'
import Pdd from '@/pages/home/goodsInfo/pdd/index.vue'
import Jd from '@/pages/home/goodsInfo/jd/index.vue'

// 用户信息
import UserInfo from '@/pages/home/userInfo/index.vue'   // 用户信息主页
import CustomerManage from '@/pages/home/userInfo/customerManage/index.vue'   // 客户管理页面
import AccountManage from '@/pages/home/userInfo/accountManage/index.vue'   // 账号管理页面



Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        },
        {
            path: '/home',
            name: 'home',
            component: Home,
            children: [
                {
                    path: '/dataEffect',
                    name: 'dataEffect',
                    component: DataEffect,
                    children: [
                        {
                            path: 'accountData',
                            name: 'accountData',
                            component: AccountData,
                        },
                        {
                            path: 'planData',
                            name: 'planData',
                            component: PlanData,
                        },
                        {
                            path: 'orderData',
                            name: 'orderData',
                            component: OrderData,
                        },
                        {
                            path: "customerData",
                            name: "customerData",
                            component: CustomerData
                        }
                    ]
                },
                {
                    path: '/goodsInfo',
                    name: 'goodsInfo',
                    component: GoodsInfo,
                    children: [
                        {
                            path: 'goodsList',
                            name: 'goodsList',
                            component: GoodsList,
                        },
                        {
                            path: 'taobao',
                            name: 'taobao',
                            component: Taobao,
                        },
                        {
                            path: 'jd',
                            name: 'jd',
                            component: Jd,
                        },
                        {
                            path: 'pdd',
                            name: 'pdd',
                            component: Pdd,
                        }
                    ]
                },
                {
                    path: '/overviewData',
                    name: 'overviewData',
                    component: OverviewDataParents,
                    children: [
                        {
                            path: 'overviewData',
                            name: 'overviewData',
                            component: OverviewData,
                        }
                    ]
                },
                {
                    path: '/userInfo',
                    name: 'userInfo',
                    component: UserInfo,
                    children: [
                        {
                            path: 'customerManage',
                            name: 'customerManage',
                            component: CustomerManage,
                        },
                        {
                            path: 'accountManage',
                            name: 'accountManage',
                            component: AccountManage,
                        }
                    ]
                }
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js